import React, { useState } from 'react';
import { PlayCircleOutlined, CloseOutlined } from '@ant-design/icons';
import { message } from 'antd';
import styles from './index.module.scss';

const VideoPlayer = ({ src, width, maxHeight }: { src: string, width: number, maxHeight: number }) => {
    const [selectedVideo, setSelectedVideo] = useState<string | null>(null);


    const handleSelectedVideo = (url: string) => {
        if (!url) {
            message.warning("视频地址错误");
            return;
        }
        setSelectedVideo(url);
    };


    return (
        <div className={styles.videoPlayerContainer}>
            {/* 缩略图和播放按钮区域 */}
            <video src={src} className={styles.sourceVideo} style={{ maxHeight: `${maxHeight}px`, width: `${width}px` }} />
            <button
                className={styles.playButton}
                onClick={() => handleSelectedVideo(src)}
            >
                <PlayCircleOutlined />
            </button>

            {/* 视频弹窗 */}
            {selectedVideo && (
                <div className={styles.modalOverlay} onClick={() => setSelectedVideo(null)}>
                    <div className={styles.modalContent} onClick={e => e.stopPropagation()}>
                        <button
                            className={styles.closeButton}
                            onClick={() => setSelectedVideo(null)}
                        >
                            <CloseOutlined />
                        </button>
                        <video
                            controls
                            autoPlay
                            className={styles.videoModal}
                            src={selectedVideo}
                        />
                    </div>
                </div>
            )}
        </div>
    );
};

export default VideoPlayer;